import { jsx as _jsx } from "react/jsx-runtime";
import { ClientLocaleWrapper } from '@src/components/ClientLocaleWrapper/ClientLocaleWrapper';
import { SegmentWrapper } from '@src/components/SegmentWrapper';
import { WeglotWrapper } from '@src/components/WeglotWrapper';
import { ContainerContextProvider } from '@src/contexts';
import { AnimateContextProvider } from '@src/contexts/AnimateContextProvider';
import { DirtyContextProvider } from '@src/contexts/DirtyContextProvider';
import en from '@src/locales/en.json';
import { Providers as CoreProviders, IntlContextProvider, getRegionAndClient, } from 'pe-core-frontend';
import { LanguagePreferenceWrapper } from '../LanguageDropdown';
const getMessages = () => en;
export const Providers = ({ children }) => {
    const { region, client } = getRegionAndClient();
    return (_jsx(CoreProviders, { gqlUrl: `/${region}/${client}/graphql`, children: _jsx(SegmentWrapper, { children: _jsx(WeglotWrapper, { children: _jsx(AnimateContextProvider, { children: _jsx(ContainerContextProvider, { children: _jsx(IntlContextProvider, { getMessages: getMessages, children: _jsx(DirtyContextProvider, { children: _jsx(LanguagePreferenceWrapper, { productName: 'pe_global', segmentAnalytics: window.analytics, children: _jsx(ClientLocaleWrapper, { children: children }) }) }) }) }) }) }) }) }));
};
